import { useTranslation } from "react-i18next";
import "../../../styles/mapStyles/Popup.css";

function SoilHealthStatus({ recommendation, soilData }) {
  const { t } = useTranslation();

  return (
    <>
      <strong className="results-title">{t("soil.soilHealthStatus")}</strong>
      <div className="soil-grid">
        {/* pH */}
        <div className="soil-item">
          <span className="label">pH</span>
          <span className="value">
            {recommendation?.ph?.statusKey
              ? t(recommendation.ph.statusKey, recommendation.ph.statusParams)
              : recommendation?.ph?.status}
          </span>
          <div>
            <span className="value-2">{soilData?.avg_ph?.toFixed(2) || "N/A"}</span>
          </div>
        </div>

        {/* SOC */}
        <div className="soil-item">
          <span className="label">SOC</span>
          <span className="value">
            {recommendation?.soc?.statusKey
              ? t(recommendation.soc.statusKey, recommendation.soc.statusParams)
              : recommendation?.soc?.status}
          </span>
          <div>
            <span className="value-2">{soilData?.avg_soc?.toFixed(2) || "N/A"} g/kg</span>
          </div>
        </div>

        {/* Nitrogen */}
        <div className="soil-item">
          <span className="label">Nitrogen (N)</span>
          <span className="value">
            {recommendation?.nitrogen?.statusKey
              ? t(recommendation.nitrogen.statusKey, recommendation.nitrogen.statusParams)
              : recommendation?.nitrogen?.status}
          </span>
          <div>
            <span className="value-2">{soilData?.avg_nitrogen?.toFixed(2) || "N/A"} g/kg</span>
          </div>
        </div>

        {/* Phosphorus */}
        <div className="soil-item">
          <span className="label">Phosphorus (P)</span>
          <span className="value">
            {recommendation?.phosphorus?.statusKey
              ? t(recommendation.phosphorus.statusKey, recommendation.phosphorus.statusParams)
              : recommendation?.phosphorus?.status}
          </span>
          <div>
            <span className="value-2">{soilData?.avg_phosphorus?.toFixed(2) || "N/A"} mg/kg</span>
          </div>
        </div>

        {/* Potassium */}
        <div className="soil-item">
          <span className="label">Potassium (K)</span>
          <span className="value">
            {recommendation?.potassium?.statusKey
              ? t(recommendation.potassium.statusKey, recommendation.potassium.statusParams)
              : recommendation?.potassium?.status}
          </span>
          <div>
            <span className="value-2">{soilData?.avg_potassium?.toFixed(2) || "N/A"} cmol/kg</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default SoilHealthStatus;
